<template>
  <f7-page>
    <instance-form loadInfo />
  </f7-page>
</template>
<script>
import InstanceForm from '../components/instanceForm'

export default {
  components: {
    InstanceForm,
  },
}
</script>
